import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // 15 minutes evergreen countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center gap-4 my-6" data-id="element-187">
      <div className="flex flex-col items-center" data-id="element-188">
        <div className="bg-red-950 text-red-400 border border-red-900 font-bold text-3xl w-16 h-16 flex items-center justify-center rounded-lg" data-id="element-189">
          00
        </div>
        <span className="text-xs text-slate-500 mt-1 font-medium uppercase tracking-wider" data-id="element-190">
          Horas
        </span>
      </div>
      <span className="text-2xl font-bold text-slate-600 -mt-5" data-id="element-191">:</span>
      <div className="flex flex-col items-center" data-id="element-192">
        <div className="bg-red-950 text-red-400 border border-red-900 font-bold text-3xl w-16 h-16 flex items-center justify-center rounded-lg" data-id="element-193">
          {minutes.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-slate-500 mt-1 font-medium uppercase tracking-wider" data-id="element-194">
          Min
        </span>
      </div>
      <span className="text-2xl font-bold text-slate-600 -mt-5" data-id="element-195">:</span>
      <div className="flex flex-col items-center" data-id="element-196">
        <div className="bg-red-950 text-red-400 border border-red-900 font-bold text-3xl w-16 h-16 flex items-center justify-center rounded-lg" data-id="element-197">
          {seconds.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-slate-500 mt-1 font-medium uppercase tracking-wider" data-id="element-198">
          Seg
        </span>
      </div>
    </div>;
}